import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WebhookInterface } from '../types/webhook-settings-interface';
import WebhookModal from './webhook-modal';
interface WebhookCreateModalProps {
  onSave?: (webhook: WebhookInterface) => void;
}
const WebhookCreateModal = t0 => {
  const $ = _c(12);
  const {
    onSave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("global.create");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <PrimaryButton onClick={t1}>{t2}</PrimaryButton>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOpen || $[7] !== onSave) {
    t5 = <WebhookModal isOpen={isOpen} onClose={t4} onSave={onSave} />;
    $[6] = isOpen;
    $[7] = onSave;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default WebhookCreateModal;